import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { parseSafetyFormRoute } from "../../services/SafetyFormRouteUtils";
import { useAppStore } from "../../store/appStore";
// User
import { useUserState } from "../../context/user";
// Components
import { NearMissTab } from "./components/nearMiss/NearMissTab";
import { SafetyAuditTab } from "./components/safetyAudit/SafetyAuditTab";
import { SafetyFormReportingTab } from "./components/reports/SafetyFormReportingTab";
import { SdsLookupTab } from "../sdsLookup/sdsLookupTab/SdsLookupTab";
// Styles
import styles from "./SafetyFormsPage.module.css";

export const SafetyFormsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUserState().currentUser;
  // Loading
  const showLoading = useAppStore((s) => s.loadingActions.showLoading);
  const hideLoading = useAppStore((s) => s.loadingActions.hideLoading);
  // Fetching the safety forms lists
  const firstFromPulledRef = useRef(false);
  const fetchInitialSafetyFormLists = useAppStore(
    (s) => s.safetyFormListsActions.fetchInitialSafetyFormLists
  );

  // Parse the route to determine which tab to show
  const parsed = parseSafetyFormRoute(location.pathname, location.search);
  const tab = parsed.tab || "near_miss"; // Default to near_miss
  // SDS Lookup does not use the safety form lists
  const needsSafetyFormLists = tab !== "sds_lookup";

  // Fetch initial safety form lists on mount
  useEffect(() => {
    if (!needsSafetyFormLists) return;
    if (!firstFromPulledRef.current && user?.employee_id) {
      firstFromPulledRef.current = true;
      const fetchData = async () => {
        showLoading("Fetching safety forms lists...");
        await fetchInitialSafetyFormLists(user.employee_id);
        hideLoading();
      };
      fetchData();
    }
  }, [
    needsSafetyFormLists,
    user?.employee_id,
    fetchInitialSafetyFormLists,
    showLoading,
    hideLoading,
  ]);

  // Render the appropriate tab based on the route
  switch (tab) {
    case "near_miss":
      return <NearMissTab />;
    case "safety_audit":
      return <SafetyAuditTab />;
    case "safety_form_reporting":
      return <SafetyFormReportingTab />;
    case "sds_lookup":
      return <SdsLookupTab />;
    // case "incident_investigation":
    //   return <IncidentInvestigationTab />;
    default:
      return <NearMissTab />;
  }
};
